// Google Analytics 4 utility wrapper
// Handles cases where gtag isn't loaded (ad blockers, etc.)

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

const GA_MEASUREMENT_ID = 'G-VGK125XRP7';

function gtag(...args: unknown[]) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag(...args);
  }
}

/** Track a custom event */
export function trackEvent(eventName: string, params?: Record<string, unknown>) {
  gtag('event', eventName, params);
}

/** Set user-level properties (membership_plan, etc.) */
export function setUserProperties(properties: Record<string, unknown>) {
  gtag('set', 'user_properties', properties);
}

/** Track a page view manually */
export function trackPageView(path: string, title?: string) {
  gtag('event', 'page_view', {
    page_path: path,
    page_title: title || document.title,
    send_to: GA_MEASUREMENT_ID,
  });
}
